import React, { JSX } from "react";
import { styled } from "styled-components";

interface ButtonsSelectorProps<T extends string> {
	options: { id: T; label: string }[];
	value: T;
	onChange: (v: T) => void;
}
export function ButtonsSelector<T extends string>({ options, value, onChange }: ButtonsSelectorProps<T>): JSX.Element {
	return (
		<Container>
			{options.map((option) => (
				<button
					key={option.id}
					onClick={() => onChange(option.id)}
					type="button"
					className={value === option.id ? "selected" : ""}
				>
					{option.label}
				</button>
			))}
		</Container>
	);
}

const Container = styled.div`
	display: flex;
	flex-direction: row;
	gap: 2px;
	background-color: ${({ theme }) => theme.colors.lightergray};
	border-radius: 100px;
	padding: 2px;

	button {
		border-radius: 100px;
		background-color: transparent;
		border: none;
		padding: 8px 12px;
		cursor: pointer;

		&.selected {
			background-color: ${({ theme }) => theme.colors.secondary};
			color: ${({ theme }) => theme.colors.white};
		}
	}
`;
